/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_SubmitInputs */

const en_us2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get code`)
};

const pt_br2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receber código`)
};

const es_419_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibir código`)
};

const pt_pt2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receber código`)
};

const fr_fr2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recevoir le code`)
};

const de_de2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code anfordern`)
};

const it_it2_auth_email_submit = /** @type {(inputs: Auth_Email_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi codice`)
};

/**
* | output |
* | --- |
* | "Get code" |
*
* @param {Auth_Email_SubmitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_submit = /** @type {((inputs?: Auth_Email_SubmitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_SubmitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_submit(inputs)
	if (locale === "es-419") return es_419_auth_email_submit(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_submit(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_submit(inputs)
	if (locale === "de-DE") return de_de2_auth_email_submit(inputs)
	if (locale === "it-IT") return it_it2_auth_email_submit(inputs)
	return en_us2_auth_email_submit(inputs)
});
export { auth_email_submit as "auth.email_submit" }